function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb401;}.cls-2{fill:#fec701;}.cls-3{fill:#fed201;}.cls-4{fill:#fee676;}.cls-5{fill:#fff;}.cls-6{fill:#4d4d4d;}.cls-7{fill:#333;}.cls-8{fill:#666;}.cls-9{fill:#1a1a1a;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M86.4037,59.6844H73.0159V56.8089H86.4037a11.0867,11.0867,0,0,0,10.739-8.3245l3.0658-11.9091a1.9511,1.9511,0,0,0-1.8895-2.4376H82.1266V31.2622H98.319a4.8265,4.8265,0,0,1,4.6742,6.03L99.9274,49.2013A13.9613,13.9613,0,0,1,86.4037,59.6844Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.984,59.6844H38.5962a13.9613,13.9613,0,0,1-13.5236-10.483L22.0067,37.2922a4.8267,4.8267,0,0,1,4.6743-6.03H42.8735v2.8755H26.681a1.9514,1.9514,0,0,0-1.89,2.4376l3.0659,11.9091a11.0866,11.0866,0,0,0,10.7389,8.3245H51.984Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M62.5,76.1887H59.3018c1.23-1.8861.1405-5.0282-1.9331-7.1574H62.5Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M62.5,76.1887h3.1982c-1.23-1.8861-.1405-5.0282,1.9331-7.1574H62.5Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M62.5,76.1887H59.3018c1.23,1.886.1405,5.028-1.9331,7.1572H62.5Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M62.5,76.1887h3.1982c-1.23,1.886-.1405,5.028,1.9331,7.1572H62.5Z"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 57.3687,
  y: 83.3459,
  width: 10.2625,
  height: 7.2346
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M64.3327,76.1887c-.8416-1.8862-.0961-5.0282,1.3227-7.1574H58.6337c1.4188,2.1292,2.1642,5.2712,1.3226,7.1574.8416,1.886.0962,5.028-1.3226,7.1572v7.2346h7.0217V83.3459C64.2366,81.2167,63.4911,78.0747,64.3327,76.1887Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M76.9661,98.0951H48.0339a.625.625,0,0,1-.5229-.9673l1.332-2.0356a16.3218,16.3218,0,0,1,8.4343-6.5257h0a16.3217,16.3217,0,0,1,10.4454,0h0a16.3218,16.3218,0,0,1,8.4343,6.5257l1.332,2.0356A.625.625,0,0,1,76.9661,98.0951Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M73.8888,97.4909H50.4456a.6174.6174,0,0,1-.4238-.9383l1.0794-1.9741a13.8519,13.8519,0,0,1,6.8342-6.329h0a11.1749,11.1749,0,0,1,8.4637,0h0a13.8529,13.8529,0,0,1,6.8341,6.329l1.0793,1.9741A.6173.6173,0,0,1,73.8888,97.4909Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M62.4412,87.4963c-6.8155,1.7308-9.6545,9.0563-9.6545,9.0563-.1955.4032.0187.9383.3756.9383h4.3836C57.1383,97.4909,56.2456,92.4935,62.4412,87.4963Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M61.9578,76.1887a34.2187,34.2187,0,0,1,.2994-7.1574H60.6681a34.2184,34.2184,0,0,1,.2993,7.1574,34.217,34.217,0,0,1-.2993,7.1572V88.37l1.5891-.7813v-4.243A34.2173,34.2173,0,0,1,61.9578,76.1887Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M57.3687,69.0313a8.7979,8.7979,0,0,1,2.3445,4.25,16.6762,16.6762,0,0,0,1.7289.3541h2.1158a16.6762,16.6762,0,0,0,1.7289-.3541,8.7987,8.7987,0,0,1,2.3445-4.25H57.3687Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M88.1636,23.9994a3.8339,3.8339,0,0,0-3.8-3.4211H40.6368a3.834,3.834,0,0,0-3.8,3.4211C33.2329,56.0912,51.638,68.9475,61.4422,70.3682h2.1157C73.3621,68.9475,91.767,56.0912,88.1636,23.9994Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M81.4138,23.9994A3.4567,3.4567,0,0,0,78.29,20.5783H42.3535A3.4567,3.4567,0,0,0,39.23,23.9994C36.2685,56.0912,51.3948,68.9475,59.4526,70.3682h1.7388C69.249,68.9475,84.3752,56.0912,81.4138,23.9994Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M52.5761,23.6275c.118-1.7321,1.117-3.0492,2.2994-3.0492H45.3446c-1.1825,0-2.1674,1.3181-2.3,3.0492C41.25,47.18,48.4833,59.1081,54.4057,63.2933a1.5636,1.5636,0,0,0,2.4079-1.72C54.89,55.2166,51.23,43.402,52.5761,23.6275Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M85.5306,20.5783H39.4694a4.04,4.04,0,0,0-4.0039,3.6093q-.1006.896-.1793,1.7726A1.2528,1.2528,0,0,0,36.54,27.3173H88.46a1.2528,1.2528,0,0,0,1.2536-1.357q-.0789-.8769-.1792-1.7725A4.0406,4.0406,0,0,0,85.5306,20.5783Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M76.8678,20.5783H40.1729c-1.642,0-3.0065,1.561-3.19,3.6093q-.08.896-.1429,1.7726a1.1708,1.1708,0,0,0,.9988,1.3571H79.2017A1.1709,1.1709,0,0,0,80.2,25.96q-.0628-.8769-.1428-1.7725C79.8745,22.1394,78.51,20.5783,76.8678,20.5783Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M41.557,23.6275c-.0965,1.2656-.1619,2.4908-.2077,3.69H50.89q.07-1.7973.1979-3.69c.1179-1.7321,1.1169-3.0492,2.2993-3.0492H43.8565C42.674,20.5783,41.689,21.8964,41.557,23.6275Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M36.4532,29.0013H88.5468c-.0271-.613-.0543-1.2261-.0985-1.8549H36.5518C36.5076,27.7752,36.48,28.3883,36.4532,29.0013Z"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 62.5,
  cy: 45.4732,
  r: 11.1787
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M63.11,39.2541l1.4227,2.8828a.68.68,0,0,0,.5122.3721l3.1813.4623a.68.68,0,0,1,.377,1.16l-2.302,2.2439a.6806.6806,0,0,0-.1957.6021l.5435,3.1685a.68.68,0,0,1-.987.7171l-2.8455-1.496a.6808.6808,0,0,0-.6331,0l-2.8454,1.496a.68.68,0,0,1-.987-.7171l.5434-3.1685a.68.68,0,0,0-.1956-.6021l-2.3021-2.2439a.68.68,0,0,1,.377-1.16l3.1814-.4623a.68.68,0,0,0,.5122-.3721L61.89,39.2541A.68.68,0,0,1,63.11,39.2541Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M98.1735,24.8664h0a4.2881,4.2881,0,0,0-4.2881-4.2881h0a4.288,4.288,0,0,0,4.2881-4.288h0a4.288,4.288,0,0,0,4.2881,4.288h0A4.2881,4.2881,0,0,0,98.1735,24.8664Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M38.8513,76.1887h0a4.2881,4.2881,0,0,0-4.2881-4.2881h0a4.288,4.288,0,0,0,4.2881-4.288h0a4.288,4.288,0,0,0,4.2881,4.288h0A4.288,4.288,0,0,0,38.8513,76.1887Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M60.6681,10.31h0A4.2881,4.2881,0,0,0,56.38,6.0221h0A4.2882,4.2882,0,0,0,60.6681,1.734h0a4.2881,4.2881,0,0,0,4.288,4.2881h0A4.288,4.288,0,0,0,60.6681,10.31Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M29.8974,19.66h0a2.5307,2.5307,0,0,0-2.5307-2.5307h0a2.5307,2.5307,0,0,0,2.5307-2.5308h0a2.5308,2.5308,0,0,0,2.5308,2.5308h0A2.5308,2.5308,0,0,0,29.8974,19.66Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M67.6313,16.6239h0a2.5308,2.5308,0,0,0-2.5308-2.5308h0a2.5307,2.5307,0,0,0,2.5308-2.5307h0a2.5306,2.5306,0,0,0,2.5306,2.5307h0A2.5307,2.5307,0,0,0,67.6313,16.6239Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M83.563,68.6505h0A2.5307,2.5307,0,0,0,81.0323,66.12h0A2.5307,2.5307,0,0,0,83.563,63.589h0A2.5308,2.5308,0,0,0,86.0938,66.12h0A2.5307,2.5307,0,0,0,83.563,68.6505Z"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 42.8851,
  y: 98.1185,
  width: 39.2208,
  height: 20.119
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M53.8017,102.8569H71.1985a4.8488,4.8488,0,0,1,4.8488,4.8488v.9388a4.8488,4.8488,0,0,1-4.8488,4.8488H53.8019a4.8491,4.8491,0,0,1-4.8491-4.8491v-.9385a4.8488,4.8488,0,0,1,4.8488-4.8488Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M62.0835,95.2235h.8335a4.295,4.295,0,0,1,4.295,4.295V116.81a4.295,4.295,0,0,1-4.295,4.295h-.8315a4.2973,4.2973,0,0,1-4.2973-4.2973V99.5188a4.2953,4.2953,0,0,1,4.2953-4.2953Z",
  transform: "translate(170.6642 45.664) rotate(90)"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 42.8851,
  y: 98.6111,
  width: 39.2208,
  height: 3.0831
});

var _ref35 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "58.692 112.876 52.798 112.876 52.798 103.452 58.692 103.452 58.692 112.875 58.692 112.876"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M41.6613,97.027H83.3438a.6435.6435,0,0,1,.6435.6435v1.7943a.6436.6436,0,0,1-.6436.6436H41.6614a.6436.6436,0,0,1-.6436-.6436V97.67A.6435.6435,0,0,1,41.6613,97.027Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M38.9063,118.6428v3.6142a1.009,1.009,0,0,0,1.009,1.009h45.17a1.009,1.009,0,0,0,1.009-1.009v-3.6142Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M40.3887,116.9522l-1.4824,1.6906H86.0938l-1.4823-1.69a2.1019,2.1019,0,0,0-1.5805-.7162H41.9692A2.1018,2.1018,0,0,0,40.3887,116.9522Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M74.8361,104.7469a.5676.5676,0,1,1-.5676-.5676A.5675.5675,0,0,1,74.8361,104.7469Z"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 74.2166,
  y: 104.3803,
  width: 0.1039,
  height: 0.7332,
  transform: "translate(-52.3145 83.1954) rotate(-45)"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 73.902,
  y: 104.6949,
  width: 0.7332,
  height: 0.1039,
  transform: "translate(-52.3145 83.1954) rotate(-45)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M74.8361,111.5813a.5676.5676,0,1,1-.5676-.5675A.5675.5675,0,0,1,74.8361,111.5813Z"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 73.902,
  y: 111.5293,
  width: 0.7332,
  height: 0.104,
  transform: "translate(100.6527 -19.8344) rotate(45)"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 73.902,
  y: 111.5293,
  width: 0.7332,
  height: 0.104,
  transform: "translate(205.6842 137.9654) rotate(135)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M51.2992,104.7469a.5676.5676,0,1,1-.5675-.5676A.5675.5675,0,0,1,51.2992,104.7469Z"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 50.3651,
  y: 104.6949,
  width: 0.7332,
  height: 0.1038,
  transform: "translate(88.9262 -5.1931) rotate(45)"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 50.3651,
  y: 104.6949,
  width: 0.7332,
  height: 0.1038,
  transform: "translate(160.6716 142.9414) rotate(135)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M51.2992,111.5813a.5676.5676,0,1,1-.5675-.5675A.5674.5674,0,0,1,51.2992,111.5813Z"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 50.3651,
  y: 111.5294,
  width: 0.7332,
  height: 0.1039,
  transform: "translate(93.7589 -3.1913) rotate(45)"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 50.3651,
  y: 111.5294,
  width: 0.7332,
  height: 0.1039,
  transform: "translate(165.5043 154.6085) rotate(135)"
});

const SvgWorldcup = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWorldcup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/worldcup.7315ff6e.svg";
export { ForwardRef as ReactComponent };